import smartParkService from "../axios";

export const sensorService = async (parkid, payloadObj) => {
    return await (await smartParkService.get('api/park/' + parkid + '/sensordata', { ...payloadObj })).data;
}